export default function formatStripeSuccess(paymentIntent) {
  var body = [
    `${(paymentIntent?.amount / 100).toFixed(2)} ${String(paymentIntent?.currency).toUpperCase()} — ${paymentIntent?.description}`,
    `ID: ${paymentIntent?.id}`,
  ];

  return body.join('\n\n');
}